/**
 * FASE 21.2 — Prayers Mutation Adapter
 */

import { createPrayer } from "../../api";
import { generateUUID } from "../../uuid";

/**
 * Create a prayer request.
 * @param {Object} payload — validated
 * @param {Object} appScope
 */
export async function createPrayerMutation(payload, appScope) {
  const now = Date.now();
  const writePayload = {
    id:               generateUUID(),
    contact_name:     payload.contact_name,
    prayer_type:      payload.prayer_type ?? "peticion_general",
    status:           "activa",
    district_id:      payload.district_id ?? appScope?.district_id ?? null,
    church_id:        payload.church_id   ?? appScope?.church_id   ?? null,
    target_person_id: payload.target_person_id ?? null,
    target_family_id: payload.target_family_id ?? null,
    created_by_kevia: true,
  };

  const data = await createPrayer(writePayload);
  return {
    ok:       true,
    entityId: data?.id ?? writePayload.id,
    summary:  `Oración registrada para ${writePayload.contact_name} (${writePayload.prayer_type}).`,
    meta:     { latency: Date.now() - now, auditType: "pastoral_care" },
  };
}
